import { render, staticRenderFns } from "./FormLogin.component.pug?vue&type=template&id=989a0b52&scoped=true&lang=pug&"
import script from "./FormLogin.component.ts?vue&type=script&lang=ts&"
export * from "./FormLogin.component.ts?vue&type=script&lang=ts&"
import style0 from "./FormLogin.component.scss?vue&type=style&index=0&id=989a0b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989a0b52",
  null
  
)

export default component.exports